export const environment = {
  general: {
    production: true,
    product: "retail",
    title: "Distrimay",
    url: "https://backend.buhomanager.com:444/",
    useMultiClient: false,
    nameMultiClient: "distrimay",
  },
  custom: {
    useGenerateUser: true,
    useContractList: false,
    useMenuFarmacia: false,
    useMenuCafeteria: false,
    useItemFotos: true,
    useItemColorAndSizes: false,
  },
  bucketconfig: {
    region: "sa-east-1",
    accessKey: "",
    secretAccessKey: "",
    bucketName: "buho-images",
    bucketFolderToSavePhotos: "multiclient/upload/photos-articles/",
    bucketFolderToSaveFiles: "multiclient/upload/files/",
  },
  Access_Token_Test:
    "TEST-8330590763883638-043014-ee9d34cc101ffbbe52b1761213d88816-170642356",
};
